import { writable, derived } from 'svelte/store';

export const flavor = writable('');
export const roast = writable('');
export const shippingFrequency = writable([null, null]);
export const size = writable('');
export const paymentFrequency = writable([null, null]);

export const flavorDisplayValue = writable(false);
export const roastDisplayValue = writable(false);
export const shippingFrequencyDisplayValue = writable(false);
export const sizeDisplayValue = writable(false);
export const paymentFrequencyDisplayValue = writable(false);

export const standardizedPaymentFrequency = derived(
  // Recharge expects frequency units to be the same, this standardizes them when needed
  [paymentFrequency, shippingFrequency],
  ([$paymentFrequency, $shippingFrequency], set) => {
    if (
      ($shippingFrequency[1] === 'Weeks' && $paymentFrequency[1] === 'Months')
    ) {
      set([$paymentFrequency[0] * 4, 'Weeks']);
    } else {
      set($paymentFrequency);
    }
  },
);
